

import { Pipe, PipeTransform } from '@angular/core';
import { POSITION_LIST } from '@app/config/position.data';

@Pipe({
  name: 'positionName'
})
export class PositionNamePipe implements PipeTransform {

  transform(value: number): string {

    value = Number(value);

    const ix: number = POSITION_LIST.findIndex(e => +e.id === +value);

    if (ix !== -1)
      return POSITION_LIST[ix].text;

    return '';
  }
}
